export default "__VITE_ASSET__C4QJlCC4__"